import { memo } from "react";

type Props = {
	guestName: string;
	guestNameKana?: string | null;
};

export const GuestNameWithTitleOfBasicInfoCompositions = memo(({ guestName, guestNameKana }: Props) => {
	return (
		<div className="text-xs 2xl:text-sm">
			<p className="lg-max:tracking-[0.15em] text-xs tracking-[0.3em] text-caption-50">{guestNameKana ?? ""}</p>

			<p className="lg-max:tracking-widest flex w-full text-left text-lg font-bold tracking-[0.15em] lg:text-xl">
				{guestName}
				<span className="mr-3 self-end text-sm">様</span>
			</p>
		</div>
	);
});
